/* ==========================================================================
   Larkville Theme — Global JS
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 12);
    });
  }

  /* ---------- Load hover-swap product image only on hover-capable devices ---------- */
  if (window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.querySelectorAll('.img-b[data-src]').forEach(function (img) {
      img.src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      if (srcset) img.srcset = srcset;
    });
  }

  /* ---------- Back to top button ---------- */
  var backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', function () {
      backToTop.classList.toggle('show', window.scrollY > 500);
    });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- Side nav scroll-spy + click-to-scroll ---------- */
  var sideBtns = document.querySelectorAll('.side-nav button');
  if (sideBtns.length) {
    var anchorSections = Array.prototype.map.call(sideBtns, function (b) {
      return document.querySelector('[data-scroll-anchor="' + b.getAttribute('data-target') + '"]');
    });
    sideBtns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (anchorSections[i]) anchorSections[i].scrollIntoView({ behavior: 'smooth' });
      });
    });
    var sideNavIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = anchorSections.indexOf(entry.target);
          if (idx > -1) {
            sideBtns.forEach(function (b) { b.classList.remove('active'); });
            sideBtns[idx].classList.add('active');
          }
        }
      });
    }, { threshold: 0.5 });
    anchorSections.forEach(function (s) { if (s) sideNavIO.observe(s); });
  }

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('.menu-toggle');
  var mobileLinks = document.querySelector('.mobile-nav-links');
  var siteHeaderEl = document.getElementById('site-header');
  function positionMobileMenu(){
    if (siteHeaderEl && mobileLinks) {
      var bottom = siteHeaderEl.getBoundingClientRect().bottom;
      mobileLinks.style.top = bottom + 'px';
      mobileLinks.style.maxHeight = 'calc(100vh - ' + bottom + 'px)';
    }
  }
  function closeMobileMenu(){ if (mobileLinks) mobileLinks.classList.remove('open'); }
  if (menuToggle && mobileLinks) {
    menuToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !mobileLinks.classList.contains('open');
      if (willOpen) positionMobileMenu();
      mobileLinks.classList.toggle('open', willOpen);
    });
    document.addEventListener('click', function (e) {
      if (mobileLinks.classList.contains('open') && !mobileLinks.contains(e.target) && e.target !== menuToggle && !menuToggle.contains(e.target)) {
        closeMobileMenu();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMobileMenu();
    });
    window.addEventListener('scroll', closeMobileMenu, { passive: true });
    window.addEventListener('resize', positionMobileMenu);
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal, .reveal-stagger');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ---------- Product card color-swatch hover swap ---------- */
  document.querySelectorAll('[data-swatch-group]').forEach(function (group) {
    var card = group.closest('.product-card');
    if (!card) return;
    var mainImg = card.querySelector('img[data-role="main"]');
    group.querySelectorAll('.pswatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.pswatch').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var newSrc = btn.getAttribute('data-img');
        var newVariantId = btn.getAttribute('data-variant-id');
        if (newSrc && mainImg) {
          mainImg.style.opacity = 0;
          setTimeout(function () {
            mainImg.src = newSrc;
            mainImg.style.opacity = 1;
          }, 150);
        }
        if (newVariantId) {
          var addBtn = card.querySelector('.p-btn-cart');
          if (addBtn) addBtn.setAttribute('data-variant-id', newVariantId);
        }
      });
    });
  });

  /* ---------- Quick add to cart from product/collection cards ---------- */
  document.querySelectorAll('.p-btn-cart[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      LarkvilleCart.add(variantId, 1);
    });
  });
});

/* ==========================================================================
   Quick View modal — fetches product data via Shopify's product.js endpoint
   ========================================================================== */
window.QuickView = (function () {
  var overlay, modal, loading, body;
  var currentProduct = null;
  var selectedOptions = [];

  var COLOR_MAP = {
    'saddle tan': '#8a5a34', 'tan': '#8a5a34',
    'black': '#1c1a19',
    'navy': '#22344a',
    'natural': '#c9a877',
    'nut brown': '#6b4530',
    'crazy horse': '#7a5330', 'crazy horse brown': '#7a5330', 'crazy-horse': '#7a5330',
    'brown': '#6b4530',
    'white': '#ffffff',
    'grey': '#8a8a8a', 'gray': '#8a8a8a'
  };
  function colorToHex(name) {
    return COLOR_MAP[(name || '').toLowerCase()] || '#c9a877';
  }

  function cacheEls() {
    overlay = document.getElementById('qvOverlay');
    modal = document.getElementById('qvModal');
    loading = document.getElementById('qvLoading');
    body = document.getElementById('qvBody');
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function open() {
    if (!overlay) return;
    overlay.classList.add('open');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('open');
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  function findVariant() {
    return currentProduct.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    });
  }

  function renderOptions() {
    var optionsEl = document.getElementById('qvOptions');
    optionsEl.innerHTML = '';
    if (currentProduct.variants.length <= 1) return;
    currentProduct.options.forEach(function (optionName, idx) {
      var values = [];
      currentProduct.variants.forEach(function (v) {
        if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
      });
      var isColor = /color|colour/i.test(optionName);
      var wrap = document.createElement('div');
      wrap.style.marginTop = '18px';
      var label = document.createElement('p');
      label.style.cssText = 'font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:8px;';
      label.textContent = optionName;
      wrap.appendChild(label);

      if (isColor) {
        var swatchWrap = document.createElement('div');
        swatchWrap.className = 'qv-swatches';
        values.forEach(function (val) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qv-swatch' + (val === selectedOptions[idx] ? ' active' : '');
          btn.style.background = colorToHex(val);
          btn.setAttribute('data-value', val);
          btn.setAttribute('aria-label', val);
          btn.addEventListener('click', function () {
            selectedOptions[idx] = val;
            renderOptions();
            updateSelection();
          });
          swatchWrap.appendChild(btn);
        });
        wrap.appendChild(swatchWrap);
      } else {
        var select = document.createElement('select');
        select.style.cssText = 'width:100%;padding:10px 12px;border:1px solid var(--line);border-radius:8px;font-family:inherit;';
        values.forEach(function (val) {
          var opt = document.createElement('option');
          opt.value = val; opt.textContent = val;
          if (val === selectedOptions[idx]) opt.selected = true;
          select.appendChild(opt);
        });
        select.addEventListener('change', function () {
          selectedOptions[idx] = select.value;
          updateSelection();
        });
        wrap.appendChild(select);
      }
      optionsEl.appendChild(wrap);
    });
  }

  function updateSelection() {
    var variant = findVariant();
    if (!variant) return;
    var priceEl = document.getElementById('qvPrice');
    priceEl.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price)
      ? '<span class="compare">' + money(variant.compare_at_price) + '</span>' + money(variant.price)
      : money(variant.price);
    var img = variant.featured_image ? variant.featured_image.src : (currentProduct.images[0] || '');
    if (img) document.getElementById('qvImage').src = img;
    var addBtn = document.getElementById('qvAddToCart');
    addBtn.setAttribute('data-variant-id', variant.id);
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';

    var buyBtn = document.getElementById('qvBuyNow');
    buyBtn.setAttribute('data-variant-id', variant.id);
    buyBtn.disabled = !variant.available;
    buyBtn.textContent = variant.available ? 'Buy it now' : 'Sold out';
  }

  function stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  function openForHandle(handle) {
    cacheEls();
    loading.style.display = 'block';
    body.style.display = 'none';
    open();

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        currentProduct = product;
        selectedOptions = product.variants[0].options.slice();
        document.getElementById('qvKicker').textContent = product.type || '';
        document.getElementById('qvTitle').textContent = product.title;
        document.getElementById('qvImage').alt = product.title;
        document.getElementById('qvFullLink').href = product.url;
        var descText = stripHtml(product.description);
        if (descText.length > 160) descText = descText.slice(0, 160).replace(/\s+\S*$/, '') + '…';
        document.getElementById('qvDescription').textContent = descText;
        document.getElementById('qvQtyInput').value = 1;
        renderOptions();
        updateSelection();
        loading.style.display = 'none';
        body.style.display = 'grid';
      })
      .catch(function (err) {
        loading.textContent = 'Could not load this product.';
        console.error('QuickView fetch failed', err);
      });
  }

  function init() {
    cacheEls();
    if (!overlay) return;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (trigger) {
        e.preventDefault();
        openForHandle(trigger.getAttribute('data-handle'));
      }
    });

    document.getElementById('qvClose').addEventListener('click', close);
    overlay.addEventListener('click', close);

    document.getElementById('qvQtyPlus').addEventListener('click', function () {
      var input = document.getElementById('qvQtyInput');
      input.value = parseInt(input.value || 1, 10) + 1;
    });
    document.getElementById('qvQtyMinus').addEventListener('click', function () {
      var input = document.getElementById('qvQtyInput');
      var v = parseInt(input.value || 1, 10);
      if (v > 1) input.value = v - 1;
    });

    document.getElementById('qvAddToCart').addEventListener('click', function () {
      var variantId = this.getAttribute('data-variant-id');
      var qty = parseInt(document.getElementById('qvQtyInput').value || 1, 10);
      if (!variantId || !window.LarkvilleCart) return;
      window.LarkvilleCart.add(variantId, qty).then(function () { close(); });
    });

    document.getElementById('qvBuyNow').addEventListener('click', function () {
      var variantId = this.getAttribute('data-variant-id');
      var qty = parseInt(document.getElementById('qvQtyInput').value || 1, 10);
      if (!variantId || !window.LarkvilleCart) return;
      window.LarkvilleCart.add(variantId, qty).then(function () { close(); });
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  return { open: openForHandle, close: close };
})();

/* ==========================================================================
   Cart drawer — talks to Shopify's Ajax Cart API
   ========================================================================== */
window.LarkvilleCart = (function () {
  var drawer, overlay, itemsEl, emptyEl, footerEl, subtotalEl, countLabel;

  function cacheEls() {
    drawer = document.getElementById('cartDrawer');
    overlay = document.getElementById('cartOverlay');
    itemsEl = document.getElementById('cartItems');
    emptyEl = document.getElementById('cartEmpty');
    footerEl = document.getElementById('cartFooter');
    subtotalEl = document.getElementById('cartSubtotal');
    countLabel = document.getElementById('cartCountLabel');
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function render(cart) {
    if (!itemsEl) return;
    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = cart.item_count;
      if (b.classList.contains('mbn-cart-count')) b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (countLabel) countLabel.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      itemsEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }
    itemsEl.style.display = 'flex';
    if (footerEl) footerEl.style.display = 'block';
    if (emptyEl) emptyEl.style.display = 'none';

    itemsEl.innerHTML = cart.items.map(function (item, idx) {
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<img src="' + item.image + '" alt="' + item.product_title + '">' +
        '<div class="cart-item-info">' +
          '<h4>' + item.product_title + '</h4>' +
          '<p class="variant">' + (item.variant_title || '') + '</p>' +
          '<div class="cart-item-bottom">' +
            '<div class="qty-mini">' +
              '<button class="qty-dec" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button class="qty-inc" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<span class="cart-item-price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button class="remove-item" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    itemsEl.querySelectorAll('.qty-inc, .qty-dec').forEach(function (btn) {
      btn.addEventListener('click', function () {
        update(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10));
      });
    });
    itemsEl.querySelectorAll('.remove-item').forEach(function (btn) {
      btn.addEventListener('click', function () { update(btn.getAttribute('data-key'), 0); });
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function add(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function () { return fetchCart(); })
      .then(function (cart) { render(cart); open(); return cart; })
      .catch(function (err) { console.error('LarkvilleCart.add failed', err); });
  }

  function update(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function (err) { console.error('LarkvilleCart.update failed', err); });
  }

  function init() {
    cacheEls();
    if (!drawer) return; // cart drawer not present on this page render (shouldn't happen, it's global)

    document.querySelectorAll('[data-cart-icon]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    var closeBtn = document.getElementById('closeCart');
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    var continueBtn = document.getElementById('continueShopping');
    if (continueBtn) continueBtn.addEventListener('click', close);

    fetchCart().then(render);
  }

  document.addEventListener('DOMContentLoaded', init);

  return { open: open, close: close, add: add, update: update, refresh: function(){ fetchCart().then(render); } };
})();
